import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { OnboardingStep } from './OnboardingStep';

interface StepMethodProps {
  onNext: () => void;
}

export function StepMethod({ onNext }: StepMethodProps) {
  return (
    <OnboardingStep>
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.6 }}
        className="text-3xl sm:text-4xl font-bold tracking-tight mb-6"
      >
        Luma is different.
      </motion.h1>
      
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.6 }}
        className="text-xl text-muted-foreground mb-6"
      >
        We don't just list tasks.
      </motion.p>
      
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8, duration: 0.6 }}
        className="text-xl text-muted-foreground mb-6"
      >
        We help you find your
      </motion.p>
      
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.1, duration: 0.5 }}
        className="mb-8"
      >
        <span 
          className="text-5xl sm:text-6xl font-bold tracking-tight text-primary"
          style={{
            textShadow: '0 0 40px hsl(var(--primary) / 0.5)',
          }}
        >
          ONE Thing
        </span>
      </motion.div>
      
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.5, duration: 0.6 }}
        className="text-lg text-muted-foreground mb-16 max-w-sm"
      >
        The single priority that makes everything else easier.
      </motion.p>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.9, duration: 0.5 }}
        className="w-full mt-4"
      >
        <Button
          size="lg"
          onClick={onNext}
          className="w-full h-14 text-lg font-medium"
        >
          I'm ready
        </Button>
      </motion.div>
    </OnboardingStep>
  );
}
